import { getCountries, type Country } from "react-phone-number-input"

import { useFetchCurrentCompany } from "@/hooks/api/companies"

export const FALLBACK_DEFAULT_COUNTRY: Country = "US"

const SUPPORTED_COUNTRIES = new Set<string>(getCountries())

export function isSupportedCountry(code: string | null | undefined): code is Country {
  return !!code && SUPPORTED_COUNTRIES.has(code)
}

export function useCompanyDefaultCountry(): Country | undefined {
  const { data: company } = useFetchCurrentCompany()
  if (!company) return undefined

  return isSupportedCountry(company.default_country) ? company.default_country : FALLBACK_DEFAULT_COUNTRY
}
